export { EmailTemplate } from "./EmailTemplate";
export { useEmailData } from "./hooks";
